import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import '@/styles.css';

const chunkReloadKey = 'everyvisit-admin-chunk-reload-v2';

function reloadAfterStaleChunk() {
  const lastReload = Number(sessionStorage.getItem(chunkReloadKey) ?? 0);
  if (Date.now() - lastReload < 30_000) return;
  sessionStorage.setItem(chunkReloadKey, String(Date.now()));
  window.location.reload();
}

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  reloadAfterStaleChunk();
});

window.addEventListener('unhandledrejection', (event) => {
  const message = event.reason instanceof Error
    ? event.reason.message
    : String(event.reason ?? '');
  if (/dynamically imported module|importing a module script failed/i.test(message)) {
    event.preventDefault();
    reloadAfterStaleChunk();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
